import request from "@/utils/request";

// 创建学生成长中心资源课程
export const stuCourseCreate = (data) => {
    return request({
        url: "/businessservice/stuCourse/create",
        method: "post",
        data: data
    })
}

// 更新学生成长中心资源课程
export const stuCourseUpdate = (data) => {
    return request({
        url: "/businessservice/stuCourse/update",
        method: "post",
        data: data
    })
}

// 查询学生成长中心资源课程详细信息
export const stuCourseInfo = (query) => {
    return request({
        url: '/businessservice/stuCourse/info',
        method: "get",
        params: query,
    })
}

// 新能学生成长中心资源课程类型
export const stuCourseClassify = (query) => {
    return request({
        url: '/businessservice/stuCourse/addClassify',
        method: "get",
        params: query,
    })
}